import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../../App";
import InventoryModal from "../../containers/shared/InventoryModal";
import NormalButton from "../shared/NormalButton";

export default function InventoryTable({ inventory,currentPage=false,pageSize=0 }) {

    const navigate = useNavigate();

    const { InventoryCategoriesOptions } = useContext(UserContext);

    const [selectedInventory, setSelectedInventory] = useState();
    const [showInventoryDetails, setShowInventoryDetails] = useState(false);


    const handleClickInventoryRow = (Inventory) => {
        
    }

    const handleClickShowPopup = (Inventory) => {
        // setSelectedInventory(Inventory);
        // setShowInventoryDetails(true);
    }

    const handleCloseModal = () => {
        setShowInventoryDetails(false);
    }

    const inventoryStatus = (inventory) => {
        if(inventory.quantity - inventory?.issuedQuantity <= inventory?.reorderPoint) {
            return <span className="text-danger">إعادة طلب</span>;
        }
        if(inventory?.issuedQuantity / inventory?.quantity > 0.75) {
            return <span className="text-warning">وشك على النفاذ</span>;
        } else {
            return <span className="text-success">متوفر</span>;
        }
    } 

    const handleShowInventoryDetails = (inventory) => {
        setSelectedInventory(inventory);
        setShowInventoryDetails(true);
    }

    const handleClickEditInventory = () => {
        navigate(`/ar/inventory/edit/${selectedInventory?._id}`);
    }


    return (
        <>
        <div className="">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">اسم المخزون</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الكود</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الفئة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">مكان التخزين</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الكمية</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الكمية المستخدمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الحالة</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]">التفاصيل</th>
                </tr>
                </thead>
                <tbody>
                {inventory.map((Inventory, index) => {;
                    return (
                    <tr key={`inventory-${index}`} className={`${index !== inventory?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === inventory?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickInventoryRow(Inventory)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}>{Inventory?.itemName}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}>{Inventory?.itemCode}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}>{InventoryCategoriesOptions[InventoryCategoriesOptions.findIndex(option => option?.value === Inventory?.category)]?.label}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}>{Inventory?.storageLocation}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}>{Inventory?.quantity}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}><span className="font-[600]" dir="ltr">{Inventory?.issuedQuantity}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickInventoryRow(Inventory)}><span className={`font-[600]`}>{inventoryStatus(Inventory)}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === inventory?.length-1 && 'rounded-bl-[8px]'}`} onClick={()=>handleClickShowPopup(Inventory)}><div className="text-blue underline font-[600] text-[14px] cursor-pointer select-none" onClick={()=>handleShowInventoryDetails(Inventory)}>تفاصيل المخزون</div></td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showInventoryDetails && <InventoryModal handleCloseModal={handleCloseModal}>
            <div className="">
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] px-[16px]">
                    <span className="text-[12px] text-grey-900 font-[600]">الاسم:</span> {selectedInventory?.itemName}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الكود:</span> {selectedInventory?.itemCode}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الفئة:</span> {InventoryCategoriesOptions[InventoryCategoriesOptions.findIndex(option => option?.value === selectedInventory?.category)]?.label}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">مكان التخزين:</span> {selectedInventory?.storageLocation}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">إجمالي الكمية:</span> {selectedInventory?.quantity}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الكمية المستخدمة:</span> {selectedInventory?.issuedQuantity}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">الحالة:</span> {inventoryStatus(selectedInventory)}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">أقل عدد مخزون لإعادة الطلب:</span> {selectedInventory?.reorderPoint}
                </div>
                <div className="text-[14px] text-grey-600 font-[500] h-[40px] leading-[40px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                    <span className="text-[12px] text-grey-900 font-[600]">معلومات المورد:</span> {selectedInventory?.supplierInfo}
                </div>
                <div className="text-end p-[16px]">
                    <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModal}>إلغاء</div>
                    <NormalButton label={'تعديل'} onClick={handleClickEditInventory} />
                </div>
            </div>
        </InventoryModal> }

        </>
    )
}

